import Vue from "vue";
import gtm from "@src/plugins/gtm";

import { router } from "@src/configs";

const configGtm = (enableInDev = false) => {
  if (process.env.NODE_ENV !== "development" || enableInDev) {
    Vue.use(gtm, {
      vueRouter: router,
      ignoredViews: ["Checkout"],
    });
  }
};

export default configGtm;
